<template>
  <div>
    <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls">
      <h3>{{$t('form.reports.overview')}}</h3>
    </div>
    <div class="admin__a-tab-content admin__a-tab-content--show">
      <registry-of-procedures-by-stages :report="shownReport"
                                        @export="$emit('export')"
                                        v-if="type == enums.ReportType.PROCEDURES_BY_STAGE">
      </registry-of-procedures-by-stages>

      <economy :report="shownReport"
               @export="$emit('export')"
               v-if="type == enums.ReportType.ECONOMY">
      </economy>

      <acceptance-price :report="shownReport"
                        @export="$emit('export')"
                        v-if="type == enums.ReportType.ACCEPTANCE_PRICE">
      </acceptance-price>

      <summary-registry :report="shownReport"
                        @export="$emit('export')"
                        v-if="type == enums.ReportType.SUMMARY_REGISTRY">
      </summary-registry>

      <nomen :report="report"
             :first-index="firstIndex"
             :last-index="lastIndex"
             @export="$emit('export')"
             v-if="type == enums.ReportType.TMC">
      </nomen>
    </div>
    <pagination :count="report.length" :page="page" :pageSize="pageSize" :sizes="[5, 10, 20, 50]" @change="onPageChange"></pagination>
  </div>
</template>

<script>
  import RegistryOfProceduresByStages from './tables/RegistryOfProceduresByStages'
  import Economy from './tables/Economy'
  import AcceptancePrice from './tables/AcceptancePrice'
  import SummaryRegistry from './tables/SummaryRegistry'
  import Nomen from './tables/Nomen'
  import Pagination from "@/components/pagination/Pagination"

  export default {
    props: {
      report: Array,
      type: String
    },

    components: {
      RegistryOfProceduresByStages,
      Economy,
      AcceptancePrice,
      SummaryRegistry,
      Nomen,
      Pagination
    },

    data: () => ({
      page: 1,
      pageSize: 5
    }),

    computed: {
      firstIndex() {
        return (this.page - 1) * this.pageSize;
      },

      lastIndex() {
        return (this.page - 1) * this.pageSize + this.pageSize;
      },

      shownReport() {
        return this.report.slice(this.firstIndex, this.lastIndex);
      }
    },

    methods: {
      onPageChange(event) {
        this.page = event.page;
        this.pageSize = event.pageSize;
      }
    }
  }
</script>

<style scoped>

</style>
